export default __webpack_public_path__ + "static/media/activity_crossword_small.e74b037e.png";